import React from 'react';
import './EducationSystem.css';

const EducationSystem: React.FC = () => {
  return (
    <section id="education" className="education-section">
      {/* Top Wave */}
      <div className="education-wave-top">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,50 C120,20 240,80 360,50 C480,20 600,80 720,50 C840,20 960,80 1080,50 C1200,20 1320,80 1440,50 L1440,0 L0,0 Z"
                fill="#EF7D3C" />
        </svg>
      </div>

      <div className="education-container">
        {/* Section Header */}
        <div className="education-header">
          <p className="education-subtitle">Eğitim Sistemimiz</p>
          <h2 className="education-title">Değer Odaklı ve Sevgi Temelli Eğitim</h2>
        </div>

        {/* Main Content */}
        <div className="education-content">
          <p className="education-description">
            Cennetin Çocukları 4-6 yaş grubu okulumuz olarak, 4-6 yaş grubu çocuklarımıza yaş gelişimlerine uygun, sevgi temelli ve değer odaklı bir eğitim sunuyoruz. Eğitim sistemimiz; Kur'an-ı Kerim öğretimi, temel dini bilgiler, ahlaki değerler, dil eğitimi ve oyun temelli öğrenme yöntemleri ile şekillendirilmiştir.
          </p>

          <p className="education-description">
            Her çocuğun bireysel farklılıklarını gözeterek hazırlanan programlarımızda, ezber yerine anlayarak öğrenme, sorgulama ve uygulama ön plandadır. Kur'an-ı Kerim eğitimi elifba, harf tanıma, tecvide giriş ve kısa sure ezberlerini kapsarken; değerler eğitimi ile çocuklarımıza saygı, sevgi, sabır, paylaşma gibi temel ahlaki kazanımlar kazandırılır.
          </p>

          <p className="education-description">
            Modern pedagojik yaklaşımları, manevi eğitimle birleştiren sistemimizde; çocuklarımızın hem dünya hayatına sağlam adımlarla hazırlanmasını, hem de manevi kimliklerini güçlü temeller üzerine inşa etmelerini hedefliyoruz.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="education-features">
          <div className="education-feature-card">
            <div className="feature-card-icon">
              <lord-icon
                src="https://cdn.lordicon.com/wxnxiano.json"
                trigger="hover"
                colors="primary:#ffffff,secondary:#ffffff"
                style={{ width: '55px', height: '55px' }}
              />
            </div>
            <h3 className="feature-card-title">Kur'an-ı Kerim Eğitimi</h3>
            <p className="feature-card-text">
              Elifba, (harf tanıma), tecvide giriş ve kısa sure ezberlerini kapsayan sevgi dolu öğretim
            </p>
          </div>

          <div className="education-feature-card">
            <div className="feature-card-icon">
              <lord-icon
                src="https://cdn.lordicon.com/ohfmmfhn.json"
                trigger="hover"
                colors="primary:#ffffff,secondary:#ffffff"
                style={{ width: '55px', height: '55px' }}
              />
            </div>
            <h3 className="feature-card-title">Değerler Eğitimi</h3>
            <p className="feature-card-text">
              Saygı, sevgi, sabır, paylaşma gibi temel ahlaki değerlerin kazandırılması
            </p>
          </div>

          <div className="education-feature-card">
            <div className="feature-card-icon">
              <lord-icon
                src="https://cdn.lordicon.com/xzalkbkz.json"
                trigger="hover"
                colors="primary:#ffffff,secondary:#ffffff"
                style={{ width: '55px', height: '55px' }}
              />
            </div>
            <h3 className="feature-card-title">Okul Öncesi Eğitim</h3>
            <p className="feature-card-text">
              4-6 yaş grubuna özel, çocukların sosyal, duygusal ve bilişsel gelişimini destekleyen kapsamlı eğitim programı
            </p>
          </div>

          <div className="education-feature-card">
            <div className="feature-card-icon">
              <lord-icon
                src="https://cdn.lordicon.com/dxjqoygy.json"
                trigger="hover"
                colors="primary:#ffffff,secondary:#ffffff"
                style={{ width: '55px', height: '55px' }}
              />
            </div>
            <h3 className="feature-card-title">Bireysel Gelişim</h3>
            <p className="feature-card-text">
              Her çocuğun bireysel farklılıklarına uygun, anlayarak öğrenme odaklı programlar
            </p>
          </div>

          <div className="education-feature-card">
            <div className="feature-card-icon">
              <lord-icon
                src="https://cdn.lordicon.com/puvaffet.json"
                trigger="hover"
                colors="primary:#ffffff,secondary:#ffffff"
                style={{ width: '55px', height: '55px' }}
              />
            </div>
            <h3 className="feature-card-title">Oyun Temelli Öğrenme</h3>
            <p className="feature-card-text">
              Modern pedagojik yaklaşımlarla manevi eğitimin birleştiği keyifli öğrenme süreci
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="education-wave-bottom">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,50 C120,80 240,20 360,50 C480,80 600,20 720,50 C840,80 960,20 1080,50 C1200,80 1320,20 1440,50 L1440,100 L0,100 Z"
                fill="white" />
        </svg>
      </div>
    </section>
  );
};

export default EducationSystem;
